/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".total-count[_ngcontent-%COMP%]{margin:20px 0;font-size:16px;display:inline-block}.header-center[_ngcontent-%COMP%]{position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);display:block}"];
export { styles as styles };
